const name = {
  session: "live-session",
  room: "live-room",
};
class Store {
  static get(key) {
    return localStorage.getItem(key);
  }

  static set(key, data) {
    localStorage.setItem(key, data);
  }

  static remove(key) {
    localStorage.removeItem(key)
  }
  
  static clear() {
    Store.remove(name.room)
    Store.remove(name.session)
  }

  static getSessionData() {
    let room;
    let session;

    try {
      session = JSON.parse(localStorage.getItem(name.session));
      room = JSON.parse(localStorage.getItem(name.room));
    } catch (err) {
      console.error(err)
    }

    return {
      accessToken: session.accessToken,
      domain: room.domain,
      roomId: room.roomId,
    };
  }

  static existingSession() {
    return !!Store.get(name.session);
  }
}

export default Store